import React from 'react';
import { createPortal } from 'react-dom';
import uuid from '../../utils/uuid';
export var TOOLTIP_CONTAINER_ID = "dm-react-tooltip-container--".concat(uuid());
export default function TooltipContext() {
  return createPortal(/*#__PURE__*/React.createElement("div", {
    id: TOOLTIP_CONTAINER_ID,
    "aria-live": "polite",
    "aria-relevant": "additions text",
    className: "auto-tooltip-container"
  }), document.body);
}